export const getCancelReason = (reason: string): string => {
  const cases = {
    plu: 'PLU',
    client: 'Client',
    mairie: 'Refus mairie',
  };

  return reason in cases ? cases[reason] : '-';
};

export const getCancelRefund = (refund: string): string => {
  const cases = {
    null: 'Aucun appel de fond reglé',
    immediate: 'Immédiat',
    '30days': 'À 30 jours',
  };

  return refund in cases ? cases[refund] : '-';
};

export const getStatusBySlug = (status: string): string => {
  const cases = {
    created: 'Nouveau',
    loss: 'Perdu',
    noshow: 'No Show',
    wc: 'Welcome Call',
    signed: 'Signé',
    mairie: 'Mairie',
    'pp-a-faire': 'PP à faire',
    'accepte-mairie': 'Accepté Mairie',
    'piece-complementaire-mairie': 'Pièce complémentaire',
    'attente-50': 'Attente 50%',
    analysisplu: 'Analyse PLU',
    'dg-paye': 'DG Payé',
    finished: 'Finit',
    'stand-by': 'Stand By',
    'installation-planifiee': 'Installation planifiée',
    'expe-paye': 'EXPE Payé',
    litige: 'Litige',
    'upsell-apres-install': 'Upsell après install',
  };

  return status in cases ? cases[status] : '-';
};
